import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { useState, useCallback } from "react";
import Logo from "./Logo";
import MegaMenuDropdown from "./MegaMenuDropdown";
import MobileNav from "./MobileNav";
import SearchBar from "./SearchBar";
import SubscribeModal from "./SubscribeModal";
import { Button } from "@/components/ui/button";
import { MEGA_MENU } from "@/data/navigation";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState<number | null>(null);
  const [subscribeOpen, setSubscribeOpen] = useState(false);
  const handleOpen = useCallback((i: number) => setOpenMenu(i), []);
  const handleClose = useCallback(() => setOpenMenu(null), []);

  return (
    <>
      <header className="border-b border-primary/10 sticky top-0 z-50" style={{ background: "rgba(10, 12, 16, 0.8)", backdropFilter: "blur(12px)", WebkitBackdropFilter: "blur(12px)" }}>
        <div className="container flex items-center justify-between h-14">
          <Link to="/" className="shrink-0">
            <Logo variant="full" />
          </Link>

          {/* Desktop mega menu */}
          <nav className="hidden lg:flex items-center gap-0.5" onMouseLeave={handleClose}>
            <Link to="/" className="px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground rounded-md transition-colors">
              Home
            </Link>
            {MEGA_MENU.map((item, i) => (
              <MegaMenuDropdown
                key={item.label}
                item={item}
                isOpen={openMenu === i}
                onOpen={() => handleOpen(i)}
                onClose={handleClose}
              />
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <SearchBar />
            <Button size="sm" className="hidden sm:inline-flex" onClick={() => setSubscribeOpen(true)}>
              Subscribe
            </Button>

            {/* Mobile hamburger */}
            <button
              className="lg:hidden h-9 w-9 rounded-md flex items-center justify-center text-muted-foreground hover:text-foreground"
              onClick={() => setMobileOpen(true)}
              aria-label="Open navigation menu"
            >
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <MobileNav isOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <SubscribeModal open={subscribeOpen} onOpenChange={setSubscribeOpen} />
    </>
  );
};

export default Header;
